var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main_center resultNoticeList",
      staticStyle: { padding: "18px" },
    },
    [
      _c(
        "div",
        { staticClass: "content", staticStyle: { padding: "0 16px" } },
        [
          _c("div", { staticClass: "search-content" }, [
            _c(
              "div",
              { staticClass: "mainBtn", staticStyle: { padding: "0" } },
              [
                _vm.hasBtnPermission("btn_portalAdministrativePenalties_add")
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.routerAdd },
                      },
                      [_vm._v("新增")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                "header-cell-style": this.$globalGrayTableHeaderStyle,
                border: "",
                stripe: "",
                height: _vm.tableMaxHeight,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  label: "序号",
                  type: "index",
                  width: "50",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "标题",
                  prop: "title",
                  fixed: "",
                  "header-align": "center",
                  align: "left",
                  "min-width": "200",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "公示期截止",
                  prop: "publicityPeriodEndTime",
                  "header-align": "center",
                  align: "center",
                  "min-width": "170",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.permanent
                                ? "永久"
                                : scope.row.publicityPeriodEndTime
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  prop: "createTime",
                  "header-align": "center",
                  align: "center",
                  "min-width": "170",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  prop: "createUser",
                  "header-align": "center",
                  align: "center",
                  "min-width": "170",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "是否发布",
                  prop: "updateTime",
                  "header-align": "center",
                  align: "center",
                  "min-width": "170",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.submitFlag ? "是" : "否")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发布时间",
                  prop: "submitTime",
                  "header-align": "center",
                  align: "center",
                  "min-width": "170",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  fixed: "right",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.hasBtnPermission(
                          "btn_portalAdministrativePenalties_detail"
                        )
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.detailSingle(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _vm._e(),
                        _vm.hasBtnPermission(
                          "btn_portalAdministrativePenalties_edit"
                        ) && !scope.row.submitFlag
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeSingle(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e(),
                        _vm.hasBtnPermission(
                          "btn_portalAdministrativePenalties_delete"
                        )
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  title: "删除",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteById(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("paginationCom", {
            staticClass: "limit",
            attrs: { options: _vm.paginationOpt },
            on: {
              sizechange: _vm.sizeChangeHandle,
              pagechange: _vm.pageChangeHandle,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }